<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ "experiences.search-title" | translate }}</h2>

<mat-dialog-content>
  <loading-spinner></loading-spinner>
  <form [formGroup]="searchForm" class="standard-form">
    <div class="grid-container">
      <!-- Name (title) Field -->
      <mat-form-field appearance="fill">
        <mat-label>{{ "title" | translate }}</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>

      <!-- Legal Name (supplier) Field -->
      <mat-form-field appearance="fill">
        <mat-label>{{ "supplier" | translate }}</mat-label>
        <input matInput formControlName="legalName" />
      </mat-form-field>

      <!-- Municipality -->
      <input-city formControlName="municipality"></input-city>

      <!-- Nation -->
      <country-select formControlName="nation"></country-select>

      <!-- Region Field -->
      <region-select formControlName="region"></region-select>
    </div>
  </form>

  <mat-divider></mat-divider>

  <!-- Search result Data Table -->
  <table
    mat-table
    [dataSource]="(dataSource$ | async) ?? []"
    matSort
    class="standard-datatable mat-elevation-z8"
  >
    <!-- Name (title) Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "title" | translate }}
      </th>
      <td mat-cell *matCellDef="let experience">{{ experience.title }}</td>
    </ng-container>

    <!-- Legal Name (supplier) Column -->
    <ng-container matColumnDef="legalName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "supplier" | translate }}
      </th>
      <td mat-cell *matCellDef="let experience">{{ experience.legalName }}</td>
    </ng-container>

    <!-- Nation Column -->
    <ng-container matColumnDef="nation">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "nation" | translate }}
      </th>
      <td mat-cell *matCellDef="let experience">{{ experience.nation | nationCode }}</td>
    </ng-container>

    <!-- Region Column -->
    <ng-container matColumnDef="region">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "region.title" | translate }}
      </th>
      <td mat-cell *matCellDef="let experience">{{ experience.region }}</td>
    </ng-container>

    <!-- Municipality Column -->
    <ng-container matColumnDef="municipality">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "municipality" | translate }}
      </th>
      <td mat-cell *matCellDef="let experience">{{ experience.cap | municipalityCap | async}}</td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let experience" class="action-column">
        <button mat-raised-button color="primary" (click)="pickExperience(experience)">
          <mat-icon>subdirectory_arrow_right</mat-icon>
          {{ "pick" | translate }}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button id="clear-filter-button" mat-stroked-button color="warn" (click)="onClearFilter()">
    <mat-icon>clear</mat-icon>
    {{ "clear-filter" | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="onSearch()">
    <mat-icon>search</mat-icon>
    {{ "search-title" | translate }}
  </button>
</mat-dialog-actions>
